<div class="success-container">
  <section>
    <app-success-authenticate
      *ngIf="workosToken && redirectUri && sessionId"
      [workosToken]="workosToken"
      [redirectUri]="redirectUri"
      [workosSessionId]="sessionId"
    />
  </section>
</div>
